import { detector } from './utils/detector';
import { build } from '../query';
import { bridge } from '../platform/bridge';
import { LINK_TYPE_MAP, INVALIDSCHEMELIST } from './constant';
import { trackLaunchAppAction } from './utils/common';
import showUserGuidView from './view/user-guid-dialog';
import showPassphraseView from './view/passphrase-dialog';
import LaunchAppUI from './view/index';
import { xenv, is } from '../xenv';
import { goTo } from '../goTo';
// location打开链接
const locationCall = (url) => {
    if (url)
        (top?.location || location).href = url;
};
// iframe打开链接
const iframeCall = (url) => {
    const vDom = {
        domKey: 'iframe',
        tag: 'iframe',
        props: { src: url },
        style: { display: 'none' }
    };
    const viewInstance = new LaunchAppUI();
    viewInstance.createUI(vDom, document.body);
    setTimeout(function () {
        viewInstance.removeUI('');
    }, 200);
};
// 是否支持location打开链接判断
const schemeJumpType = (scheme) => {
    const isIos = detector.os.name === 'ios';
    const isAndroid = detector.os.name === 'android';
    const isIOSWithLocationCallSupport = isIos && detector.browser.name == 'safari' && detector.os.version >= 9;
    const isChromeWithLocationCallSupport = detector.browser.name == 'chrome' && detector.browser.version > 55;
    const isSamsungWithLocationCallSupport = detector.browser.name == 'samsung';
    const isAndroidWithLocationCallSupport = isAndroid && (isChromeWithLocationCallSupport || isSamsungWithLocationCallSupport);
    let isValidsScheme = true;
    for (let i = 0; i < INVALIDSCHEMELIST.length; i++) {
        if (new RegExp(INVALIDSCHEMELIST[i]).test(scheme)) {
            isValidsScheme = false;
        }
    }
    if (isIos && xenv() === 'passenger' && isValidsScheme)
        return 'business';
    if (isIOSWithLocationCallSupport || isAndroidWithLocationCallSupport) {
        return 'location';
    }
    else {
        return 'iframe';
    }
};
const getDeepLink = (targetDeepLink) => {
    const { extraParam, link } = targetDeepLink || {};
    let url = link;
    if (extraParam?.originalID && extraParam?.path) {
        url = extraParam.path; // 此时link为空，使用 extraParam.path
    }
    return url;
};
// scheme拉端
const handleScheme = (url) => {
    if (!url || url.length < 1)
        return;
    const jumpMethod = schemeJumpMethodMap[schemeJumpType(url)];
    jumpMethod && jumpMethod(url);
};
const schemeJumpMethodMap = {
    'location': (url) => {
        locationCall(url);
    },
    'iframe': (url) => {
        iframeCall(url);
    },
    'business': (url) => {
        goTo({
            scheme: url,
            extParams: {
                schemeJumpMethod: 'switchToBusinessPage'
            }
        });
    },
};
// linkType对应的具体拉端方法
const launchMethodMap = {
    [LINK_TYPE_MAP.universal_link]: (launchConfig) => {
        const { url } = launchConfig;
        locationCall(url);
    },
    [LINK_TYPE_MAP.scheme]: (launchConfig) => {
        const { url } = launchConfig;
        handleScheme(url);
    },
    [LINK_TYPE_MAP.wx_scheme]: (launchConfig) => {
        const { url } = launchConfig;
        handleScheme(url);
    },
    [LINK_TYPE_MAP.download]: (launchConfig) => {
        const { action, link } = launchConfig;
        const downloadMethod = downloadMethodMap[action];
        downloadMethod ? downloadMethod(launchConfig) : locationCall(link);
    },
    [LINK_TYPE_MAP.passphrase]: () => showPassphraseView,
    [LINK_TYPE_MAP.bridge]: (launchConfig) => {
        const { extraParam, browser, closeAfterLaunch } = launchConfig;
        const { originalID, path, type } = extraParam;
        if (!browser || browser === 'kuaishou') {
            window['callback_openWechatMiniProgram'] = (e) => {
                console.log('callback_openWechatMiniProgram====>', e);
            };
            const KwaiAdThird = window['KwaiAdThird'];
            if (KwaiAdThird) {
                const params = {
                    'action': 'openWechatMiniProgram',
                    'data': JSON.stringify({ originalID, path, type }),
                    'callback': 'callback_openWechatMiniProgram'
                };
                KwaiAdThird.callAdBridge(JSON.stringify(params)).then(res => {
                    console.log('调用成功！', res);
                }).catch(e => {
                    console.error('调用失败', e);
                });
            }
        }
        else if (browser === 'didi') {
            bridge.launchWeChatMiniApp({
                appId: originalID,
                path,
                programType: type,
            }, res => {
                if (!closeAfterLaunch)
                    return;
                if (res.errno === 0) {
                    window.history.go(-1);
                    setTimeout(() => {
                        if (!document.referrer && window.history.length === 1) {
                            bridge.closePage({});
                        }
                    });
                }
            });
        }
    },
    [LINK_TYPE_MAP.ali_scheme]: (launchConfig) => {
        const { url } = launchConfig;
        handleScheme(url);
    },
    [LINK_TYPE_MAP.show_guid]: () => {
        showUserGuidView();
    }
};
// action对应的具体下载方式
const downloadMethodMap = {
    guide_download: (launchConfig) => {
        const { extra = {} } = launchConfig;
        const { guidePageUrl } = extra;
        // 跳转引导中间页
        if (guidePageUrl) {
            locationCall(guidePageUrl);
        }
        else {
            // 展示蒙层引导 引导用户去浏览器中打开活动页面
            showUserGuidView();
        }
    },
    android_download: (launchConfig) => {
        const { extra = {}, link } = launchConfig;
        const { apkUrl } = extra;
        // 安卓下载
        let url = link;
        if (apkUrl) {
            url = apkUrl;
        }
        locationCall(url);
    },
    ios_download: (launchConfig) => {
        const { link } = launchConfig;
        locationCall(link);
    }
};
class LaunchAppControl {
    constructor(launchAppOptions) {
        this.launchAppOptions = launchAppOptions;
        this.formatOptions(launchAppOptions);
    }
    // 开始拉端
    handleLaunch(deepLink) {
        this.formatDeepLink(deepLink);
        const { linkType } = this.launchConfig;
        const launchMethod = launchMethodMap[linkType];
        launchMethod && launchMethod(this.launchConfig);
        trackLaunchAppAction(getDeepLink(this.launchConfig.targetDeepLink));
    }
    // 格式化通用参数
    formatOptions(launchAppOptions) {
        const { launchAppConfig = { extra: {}, isUseWeixinTag: false, hadInvokeApp: false }, strategyData = { pullType: 0, browser: '' } } = launchAppOptions;
        const { isAutoInvokeApp, isHideLaunchAppView, extra, isUseWeixinTag, hadInvokeApp, copySuccess, copyFail, closeAfterLaunch } = launchAppConfig;
        const { pullType, browser } = strategyData;
        this.launchConfig = {
            launchAppOptions,
            pullType,
            isAutoInvokeApp,
            isHideLaunchAppView,
            browser,
            extra,
            isUseWeixinTag,
            hadInvokeApp,
            copySuccess,
            copyFail,
            closeAfterLaunch,
        };
    }
    // 格式化拉端参数
    formatDeepLink(deepLink) {
        const { strategyData } = this.launchAppOptions;
        const { mainDeepLinks, pullFailDeepLinks } = strategyData;
        // 如果主拉端方式是universal link，并且候补拉端有download，跳转时带上口令
        if (mainDeepLinks.linkType === 1) {
            const iosDownloadLink = pullFailDeepLinks.filter(linkObj => linkObj.linkType === LINK_TYPE_MAP.download)[0] || {};
            const cmd = iosDownloadLink.cmd || '';
            mainDeepLinks.cmd = cmd;
            if (is('weixin')) {
                // 如果是微信universalink，跳转失败，拼接参数
                mainDeepLinks.link = build(mainDeepLinks.link, {
                    can_open_np: '1',
                });
            }
        }
        const targetDeepLink = deepLink || mainDeepLinks;
        const { linkType, link, cmd, action, extraParam, target_xenv } = targetDeepLink;
        const extendParams = {};
        // webx_with_cmd=1 参数，端先执行 scheme/universllink 同时识别到了 webx_with_cmd=1 ，就会取消口令，防止打开两次页面；
        if (target_xenv === 'passenger') { // 如果是拉app乘客端，拼接webx_with_cmd=1
            extendParams.webx_with_cmd = 1;
        }
        let url = linkType === LINK_TYPE_MAP.universal_link ? build(link, { cmd: encodeURIComponent(cmd), ...extendParams }, true) : linkType === LINK_TYPE_MAP.scheme ? build(link, extendParams, true) : link;
        const deepLinkConfig = {
            targetDeepLink,
            linkType,
            link,
            action,
            extraParam,
            url,
            cmd
        };
        this.launchConfig = Object.assign(this.launchConfig, deepLinkConfig);
    }
}
export { LaunchAppControl };
